(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ugc-carousel"] && !Shopify.designMode) return;
  try {
    

class VideoCard extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.videoCard = this.querySelector(".m-video-card");
        this.button = this.querySelector(".m-video-card__button");
        this.playButton = this.querySelector(".m-video-card__play");
        this.pauseButton = this.querySelector(".m-video-card__pause");
        this.video = this.querySelector(".m-video-card__video video");
        this.videoIsPlaying = this.dataset.videoIsPlaying;

    
        this.button.addEventListener("click", (e) => {
         
            if (this.videoIsPlaying == 'true') {
                console.log('pause')
                this.video.pause();
                this.playButton.classList.remove("m:hidden");
                this.pauseButton.classList.add("m:hidden");
                this.videoIsPlaying = 'false';
                this.setAttribute("data-video-is-playing", "false");
                
            } else {
                console.log('play')
                this.video.play();
                console.log("play");
                this.playButton.classList.add("m:hidden");
                this.pauseButton.classList.remove("m:hidden");
                this.videoIsPlaying = 'true';
                this.setAttribute("data-video-is-playing", "true");
               
            }
        });


    
}
}


if(!customElements.get("video-card")){
    customElements.define("video-card", VideoCard);
}


let rbSwiper;
let slider = document.querySelector('.ugc-carousel-wrapper.swiper');

function initSwiper() {
  if (slider && typeof MinimogLibs !== 'undefined' && typeof MinimogLibs.Swiper !== 'undefined') {
    if (rbSwiper) rbSwiper.destroy(true, true); // Destroy existing swiper if exists

    rbSwiper = new MinimogLibs.Swiper(slider, {
      slidesOffsetBefore: 15,
      slidesOffsetAfter:15,
      speed: 400,
      slidesPerView: 5,
      spaceBetween: 15,
      navigation: {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev")
      },
      breakpoints: {
        0: {
          slidesPerView: 2.4
        },
        649: {
          slidesPerView: 2.4
        },
        989: {
          slidesPerView: 6.12,
          allowTouchMove: false
        }
      }
    });
  }
}

window.addEventListener('load', initSwiper);
window.addEventListener('resize', () => {
  clearTimeout(window.__swiperResizeTimeout);
  window.__swiperResizeTimeout = setTimeout(() => {
    initSwiper(); // Re-init on resize
  }, 300); // debounce
});

    


  } catch(e) { console.error(e); }
})();
})();
